import { ChangeDetectionStrategy, Component, ElementRef, HostBinding, HostListener, contentChild, inject, input, output } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { XpDialogHeaderComponent } from '../dialog-header/xp-dialog-header.component';

@Component({
	selector: 'xp-drawer',
	standalone: true,
	imports: [MatCardModule],
	templateUrl: './xp-drawer.component.html',
	styleUrls: ['./xp-drawer.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class XpDrawerComponent {
	clickThrough = input(false);
	ariaLabel = input('');
	closed = output<void>();
	header = contentChild(XpDialogHeaderComponent);

	private readonly host: HTMLElement = inject(ElementRef).nativeElement;

	@HostBinding('class.xp-drawer--click-through')
	get isClickThrough(): boolean {
		return this.clickThrough();
	}

	@HostListener('click', ['$event'])
	onClick(event: MouseEvent): void {
		if (!this.clickThrough() && event.target === this.host) {
			this.closed.emit();
		}
	}
}
